import { makeVar } from '@apollo/client';

const userLogged = makeVar<string | null>(null);

const shopType = makeVar<'full' | 'light'>('full');

export { userLogged, shopType };
